import { usePolyPlusEnabledQuery } from "../generated/graphql";

export const usePolyPlusEnabled = (tenantId: string) => {
  const { data, fetching } = usePolyPlusEnabledQuery({
    variables: { tenantId },
    pause: !tenantId
  });

  return {
    polyPlusEnabled: !fetching && data?.polyPlusEnabled,
    fetching: fetching
  };
};
